<template>
    <PageFrameInset maxWidth="500px">

        <template v-if="resetSent">
            <div class="form-group form-group-header">
                <h1>Reset instructions have been sent to {{email}}</h1> 
            </div>
            <div class="form-group">
                <p>If you cannot find the reset email in the next 15 minutes, check your spam foler.</p> 
            </div>
            <div class="form-group form-group-footer">
                <router-link to="/login">Login</router-link>
                <router-link to="/register">Create an Account</router-link>
            </div>
        </template>

        <template v-else-if="resetFailed">
            <div class="form-group form-group-header">
                <h1>ERROR! Reset instructions could not be sent to {{email}}</h1> 
            </div>
            <div class="form-group">
                <p>Wait 10 minutes and try again. If you continue to experience problems, please <router-link to="/">Contact Us</router-link>.</p> 
            </div>
            <div class="form-group form-group-footer">
                <router-link to="/">Home Page</router-link>
                <router-link to="/forgot">Try Again</router-link>
            </div>
        </template>

        <template v-else>
            <div class="form-group form-group-header">
                <h1>Reset your password</h1>
                <p>Forgotten your password? Enter your email to reset your account.</p>  
            </div>
            <div class="row stack">
                <OSJLabel
                    :theme="theme"
                    :size="size"
                    required>
                    Email
                </OSJLabel>
                <OSJInput
                    placeholdertext="email@mail.com"
                    type="email"
                    v-model="email"
                    required>
                </OSJInput>
            </div>
            <div class="form-group">
                <Btn block @clicked="validateForm">Send Reset Instructions</Btn>
            </div>
            <div class="form-group form-group-footer">
                <router-link to="/login">Login</router-link>
                <router-link to="/register">Create an Account</router-link>
            </div>
        </template>
    </PageFrameInset>
</template>
<script>
    import firebase from 'firebase/app';
    import PageFrameInset from '@/components/PageFrameInset.vue'
    import Btn from '@/components/Btn.vue'
    import OSJInput from '@/components/OSJInput.vue'
    import OSJLabel from '@/components/OSJLabel.vue'

    export default {
        name: "register",
        components : {
            PageFrameInset,
            OSJInput,
            OSJLabel,
            Btn
        },
        data(){
            return {
                email: "",
                // theme and style
                theme: 'dark',
                size: 'small',
                resetSent: false,
                resetFailed: false
            }
        },
        methods: {
            reset () {
                firebase
                    .auth()
                    .sendPasswordResetEmail(this.email)
                    .then(() => {
                        // window.alert('Password reset email sent, check your inbox.')
                        this.resetSent = true
                    })
                    .catch(() => {
                        // window.alert(error)
                        this.resetFailed = true
                    })
            },
            validateForm ( { event } ) {
                if (this.email !== "") {
                    this.reset();
                }
                // console.log( event )
                event.preventDefault()
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/vars";

    .form-group{
        margin-bottom: 2rem;

        &-header{
            border-bottom: 1px solid #ddd;
        }

        &-footer{
            border-top: 1px solid #ddd;
            padding-top: 2rem;
            text-align: center;

            a{
                display: inline-block;
                padding: 0.5rem;
                
                &:first-child{
                    margin-right: 0.5rem;
                }
            }
        }
    }
</style>